import { render, staticRenderFns } from "./ReplicarConfiguracaoModelo.vue?vue&type=template&id=29d82250&"
import script from "./ReplicarConfiguracaoModelo.vue?vue&type=script&lang=js&"
export * from "./ReplicarConfiguracaoModelo.vue?vue&type=script&lang=js&"
import style0 from "./ReplicarConfiguracaoModelo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports